import Api from '@/axios/api'

export default {
  getUsers ({ getters, commit }) {
    commit('setLoading',  true)
    commit('setCurrentPage', 1)

    Api.get('/customer/subaccounts', {
      params: getters.params,
    })
    .then(({ data, meta, links }) => {
      commit('setUsers', data)
      commit('setMeta', meta)
      commit('setLinks', links)
    })
    .catch((e) => (console.error(e)))
    .finally(() => {
      commit('setLoading',  false)
    })
  },
  getUsersIds ({ getters, commit }) {
    return Api.get('/customer/subaccounts/ids', {
      params: getters.params,
    })
      .then(({ data }) => {
        const ids = data?.ids ?? [];
        commit('setUsersIds', ids);
        return ids;
      })
      .catch((e) => (console.error(e)))
  },
  async loadMoreUsers ({ state, getters, commit }) {
    commit('setCurrentPage', state.currentPage + 1)

    return Api.get('/customer/subaccounts', {
      params: {
        page: state.currentPage,
        ...getters.params
      }
    })
    .then(({ data, meta, links }) => {
      commit('addUsers', data)
      commit('setMeta', meta)
      commit('setLinks', links)
    })
    .catch((e) => (console.error(e)))
  },
  async getUserTags({ commit }) {
    try {
      const { data: { tags } } = await Api.get('/customer/subaccounts/additional-data')
      const formattedTags = (tags || []).map(tag => ({
        ...tag,
        isFromApi: true // all tags from API are getting a flag
      }))
      commit('setTags', formattedTags)
      return formattedTags
    } catch (e) {
      console.error(e)
    }
  },
  async syncUserTags(_, tags) {
    try {
      await Api.post('/customer/subaccounts/tags/sync', { tags })
    } catch (error) {
      console.error(error)
    }
  }
}
